/* eslint-disable no-unused-vars */
import { Grid, Typography } from "@mui/material";

import { createFilterOptions } from "@mui/material/Autocomplete";
import PDialog from "../../../components/pos/PDialog";
import PSelect from "../../../components/pos/PSelect";
import PText from "../../../components/pos/PText";
import db from "../../../db/db";
import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import AsyncSelect from "react-select/async";
import API from "../../../utils/API";
import { PrintUtils } from "../../../utils/PrintUtils";
import { SyncUtils } from "../../../utils/SyncUtils";
import GenericReportViewer from "./../../reports/GenericReportViewer";
import CashFlowDigitPanel from "./CashFlowDgitPanel";
import { SaleUtils } from "../../../utils/SaleUtils";

let prevTime = 0;

export default function PayinCrud(props) {
  const { t } = useTranslation();
  const translate = t;
  const [customerLookupValue, setCustomerLookupValue] = useState();
  const [origObject, setOrigObject] = useState(null);
  const [mode, setMode] = useState("create");
  const [openWindow, setOpenWindow] = useState(false);
  const [windowTitle, setWindowTitle] = useState("");

  const [confirmContext, setConfirmContext] = useState({ open: false });
  const [confirmOpen, setConfirmOpen] = useState(false);

  const [liveValidation, setLiveValidation] = useState(false);

  const [customer, setCustomer] = useState("");
  const [customerError, setCustomerError] = useState("");
  const [customerOptions, setCustomerOptions] = useState([]);
  const [amount, setAmount] = useState("");
  const [amountError, setAmountError] = useState("");
  const [paymentMode, setPaymentMode] = useState("");
  const [paymentModeError, setPaymentModeError] = useState("");
  const [paymentModeOptions, setPaymentModeOptions] = useState([]);
  const [description, setDescription] = useState("");
  const [descriptionError, setDescriptionError] = useState("");
  const [transactionType, setTransactionType] = useState("");
  const [reasonCode, setReasoncode] = useState("");
  const [reasonCodeError, setReasoncodeError] = useState("");
  const [origin, setOrigin] = useState("");
  const [printEnable, setPrintEnable] = useState(false);
  /*CODEGEN_STATE_INIT ######## DO_NOT_REMOVE ###########*/

  props.biRef.payin = {
    showPaymentTransactionCrudWindow: showPaymentTransactionCrudWindow,
  };

  useEffect(() => {}, []);
  useEffect(() => {}, []);

  useEffect(() => {
    if (liveValidation && customer === "")
      setCustomerError(translate("Customer is Required"));
    else setCustomerError("");
  }, [customer]);
  useEffect(() => {
    if (liveValidation && amount === "")
      setAmountError(translate("Amount is Required"));
    else setAmountError("");
  }, [amount]);
  useEffect(() => {
    if (liveValidation && paymentMode === "")
      setPaymentModeError(translate("Payment mode is Required"));
    else setPaymentModeError("");
  }, [paymentMode]);
  /* useEffect(() => {
    if (liveValidation && description === "")
      setDescriptionError("Description is Required");
    else setDescriptionError("");
  }, [description]);*/
  useEffect(() => {
    if (liveValidation && reasonCode === "")
      setReasoncodeError(translate("Reasoncode is Required"));
    else setReasoncodeError("");
  }, [reasonCode]);
  /*CODEGEN_INIT_USE_EFFECT ######## DO_NOT_REMOVE ###########*/

  /* async function loadCustomerOptions() {
    let customer = await axios.get("/api/v1/allcustomers");
  async function loadCustomerOptions() {
    let customer = await API.get("/api/v1/allcustomers");

    populateCustomerOptions(customer.data);
  }*/

  const getOptions = (inputValue, callback) => {
    getOptionsAsync(inputValue, callback);
  };

  async function getOptionsAsync(inputValue, callback) {
    let dbData = await db.customer
      .where("name")
      .startsWithIgnoreCase(inputValue)
      .or("custId")
      .startsWithIgnoreCase(inputValue)
      .or("micrCode")
      .startsWithIgnoreCase(inputValue)
      .or("mobile")
      .startsWithIgnoreCase(inputValue)
      .limit(10)
      .toArray();

    let arr = [];
    let count = 0;
    for (let i = 0; i < dbData.length; i++) {
      if (!dbData[i].creditCustomer) {
        continue;
      } else if (count < 10) {
        let val = {
          id: dbData[i].id,
          name: dbData[i].name,
          custId: dbData[i].custId,
          micrCode: dbData[i].micrCode,
          bean: dbData[i],
        };
        arr.push(val);
        count++;
      } else {
        break;
      }
    }

    return callback(
      arr.map(function (option, index) {
        return {
          value: option,
          label: option,
        };
      })
    );

    //return callback([]);
  }

  const formatOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <Grid container>
          <Grid item xs={3}>
            {option.value.custId}
          </Grid>
          <Grid item xs={6}>
            {option.value.name}
          </Grid>
          <Grid item xs={3}>
            {option.value.dueAmount}
          </Grid>
        </Grid>
      );
    }
    if (!option.label) return "";
    return option.label.name;
  };

  // const customerLookupChanged = (newValue) => {
  //   console.log("selected customer : " + JSON.stringify(newValue));
  //   setCustomer(newValue.value.bean);
  //   setCustomerLookupValue({ label: newValue.value, value: newValue });
  // };

  /*function populateCustomerOptions(data) {
    let dataArray = [];
    setCustomerOptions([]);
    data.map((item, key) => dataArray.push({ value: item, name: item.name }));
    setCustomerOptions(dataArray);
  }*/

  function showPaymentTransactionCrudWindow(origin, transType, id) {
    setOrigin(origin);
    setWindowTitle(transType);

    //loadCustomerOptions();
    resetFields();
    setTransactionType(transType);
    setPaymentModeOptions([{ name: "CASH" }, { name: "CARD" }]);
    setLiveValidation(false);
    setCustomerLookupValue(null);
    setOpenWindow(true);
  }
  async function populatePayin(id) {
    {
      try {
        let { data } = await API.get("/api/v1/payin/" + id);
        setOrigObject(data);
        populateData(data);
        setOpenWindow(true);
      } catch (err) {
        console.error(err);
        props.showMessage(
          "error",
          translate("Not able to retrive Payin data from server")
        );
      }
    }
  }
  function onKeyPressed(value) {
    if ("Backspace" === value) {
      if (amount.length > 0) {
        setAmount(amount.substring(0, amount.length - 1));
      }
    } else if ("Delete" === value) {
      setAmount("");
    }
    if (isValidkey(value)) {
      let curTime = new Date().getTime();
      if (curTime - prevTime < 2000) {
        setAmount(amount + "" + value);
      } else {
        setAmount(value);
      }
      prevTime = curTime;
    }
  }

  function isValidkey(value) {
    return (
      "1" == value ||
      "2" == value ||
      "3" == value ||
      "4" == value ||
      "5" == value ||
      "6" == value ||
      "7" == value ||
      "8" == value ||
      "9" == value ||
      "0" == value ||
      "." == value
    );
  }

  var biRef = {};

  function populateData(bean) {
    setCustomer(
      bean.customer ? { id: bean.customer, name: bean.customer } : null
    );

    setAmount(bean.amount);
    setPaymentMode(
      bean.paymentMode ? { id: bean.paymentMode, name: bean.paymentMode } : null
    );

    setDescription(bean.description);
    setReasoncode(bean.reasonCode);
    /*CODEGEN_POPULATE_DATA ######## DO_NOT_REMOVE ###########*/
  }

  function resetFields() {
    setMode("create");
    setCustomer("");
    setCustomerError("");
    setAmount("");
    setAmountError("");
    setPaymentMode("");
    setPaymentModeError("");
    setDescription("");
    setDescriptionError("");
    setReasoncode("");
    setReasoncodeError("");
    /*CODEGEN_RESET_FIELDS ######## DO_NOT_REMOVE ###########*/
  }

  function onCloseWindow() {
    setOpenWindow(false);
  }

  /* function onDelete() {
    setConfirmOpen(true);
    setConfirmContext({
      title: "Are You Sure",
      message: "Are you sure to delete payin :" + origObject.name + " ?",
      type: "warning",
      open: true,
      yes: true,
      no: true,
    });
  }*/

  /* async function onYesNoClicked(context, value) {
    setConfirmOpen(false);
    if (value == "yes") {
      try {
        let result = await API.delete(
          "/api/v1/payin/" + origObject.id
        );
        props.showMessage("warning", "Payin " + name + " got Removed");
        props.onRefresh();
        setOpenWindow(false);
      } catch (err) {
        props.showMessage("error", "Not able to Delete Payin");
      }
    }
  }*/

  function payinPrint(result) {
    if (origin === "sale") {
      PrintUtils.printReceipt(
        props.terminalBean,
        transactionType === "payin"
          ? "PAY_IN_RECEIPT_FORMAT"
          : "PAY_OUT_RECEIPT_FORMAT",
        result.data,
        props.setAlert,
        true,
        translate,
        false,
        false,
        null,
        props.pdfViewer
      );
    } else if (origin === "customer") {
      let paramsList = [
        {
          key: "payInId",
          value: result.data.id,
        },
      ];

      biRef.genericReportView.showGenericReportViewer(
        "reports/generic/payin_customer_receipt",
        paramsList,
        translate("Customer Payin Report")
      );
    }
  }

  async function onSave(needPrint) {
    if (validate() && mode === "create") {
      console.log("origin: " + origin);
      var payload = createPayload();
      try {
        let result = await API.post("/api/v1/paymenttransaction", payload);
        props.showMessage("success", translate("Saved Successfully"));
        setMode("edit");
        SyncUtils.requestSync(result.headers);
        // props.onRefresh();
        setOpenWindow(false);
        if (needPrint) {
          console.log("print enabled...");
          payinPrint(result);
        }
      } catch (err) {
        console.log(err);
        if (err.response && err.response.status == 412) {
          showDetailedError(err.response.data);
        } else {
          //showMessage("error", "Not able to Save Payin");
        }
      }
    }
  }

  function showDetailedError(msg) {
    for (var i = 0; i < msg.messageList.length; i++) {
      var obj = msg.messageList[i];
      /*if (obj.field === "name") {
        setNameError(obj.message);
      }*/
      if (obj.field === "customer") {
        setCustomerError(obj.message);
      }
      if (obj.field === "amount") {
        setAmountError(obj.message);
      }
      if (obj.field === "paymentMode") {
        setPaymentModeError(obj.message);
      }
      /* if (obj.field === "description") {
        setDescriptionError(obj.message);
      }*/
      if (obj.field === "reasonCode") {
        setReasoncodeError(obj.message);
      }
      /*CODEGEN_DETAILED_ERROR ######## DO_NOT_REMOVE ###########*/
    }

    props.showMessage("error", msg.message);
  }

  function createPayload() {
    let saveObject = Object.create(null);
    console.log(mode);
    saveObject["transactionType"] = transactionType;
    saveObject["customerId"] = customer.id;
    saveObject["amount"] = amount;
    saveObject["paymentMode"] = paymentMode.name;
    saveObject["description"] = description;
    saveObject["reasonCode"] = reasonCode;
    saveObject["currentDue"] = 0;
    saveObject["payCode"] = paymentMode.name;

    if (props.saleSession) {
      saveObject["saleSessionId"] = props.saleSession.id;
      saveObject["shiftSessionId"] = SaleUtils.getShiftSaleSessionId(
        props.saleSession
      );
    }
    /*CODEGEN_CREATE_PAYLOAD ######## DO_NOT_REMOVE ###########*/
    if (mode == "create") {
      saveObject["id"] = null;
      saveObject["intVersion"] = 0;
    }
    return saveObject;
  }

  function validate() {
    let flag = true;

    // if (transactionType === "payin" && (!customer || customer === "")) {
    //   setCustomerError(translate("Customer is Required"));
    //   flag = false;
    // }
    
    if (!amount || amount === "") {
      setAmountError(translate("Amount is Required"));
      flag = false;
    }
    if (!paymentMode || paymentMode === "") {
      setPaymentModeError(translate("Payment mode is Required"));
      flag = false;
    }
    /*if (!description || description === "") {
      setDescriptionError("Description is Required");
      flag = false;
    }*/
    if (transactionType === "payout" && (!reasonCode || reasonCode === "")) {
      setReasoncodeError(translate("Reason code is Required"));
      flag = false;
    }
    /*CODEGEN_VALIDATE ######## DO_NOT_REMOVE ###########*/
    if (!flag) {
      setLiveValidation(true);
    }
    return flag;
  }

  const filterOptions = createFilterOptions({
    matchFrom: "any",
    stringify: (option) =>
      option.name +
      option.value.custId +
      option.value.phone +
      option.value.mobile,
  });

  function onPrintClicked() {
    onSave(true);
  }

  function onSaveClicked() {
    onSave(false);
  }

  const content = (
    <div  style={{ height: "250px" }}>
      <Grid container spacing={4}>
        <Grid item xs={12} sm={origin == "sale" ? 8 : 12}>
          <table width="100%">
            <tbody>
              {transactionType == "payout" && (
                <tr>
                  <td>
                    <Typography variant="body1">
                      {translate("Payout Reason")} Code
                    </Typography>
                  </td>
                  <td>
                    <PText
                      value={reasonCode}
                      error={reasonCodeError}
                      onChange={(e) => setReasoncode(e.target.value)}
                    ></PText>
                  </td>
                </tr>
              )}
              {transactionType == "payin" && (
                <tr>
                  <td>
                    <Typography variant="body1">
                      {translate("Pay -In Reason")}
                    </Typography>
                  </td>
                  <td>
                  <PText
                      value={reasonCode}
                      error={reasonCodeError}
                      onChange={(e) => setReasoncode(e.target.value)}
                    ></PText>
                  </td>
                </tr>
              )}

              <tr>
                <td>
                  <Typography variant="body1">{translate("Amount")}</Typography>
                </td>
                <td>
                  <PText
                    value={amount}
                    error={amountError}
                    onChange={(e) => {
                      if (!isNaN(e.target.value)) setAmount(e.target.value);
                    }}
                  ></PText>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Payment Mode")}
                  </Typography>
                </td>
                <td>
                  <PSelect
                    options={paymentModeOptions}
                    value={paymentMode}
                    errorMessage={paymentModeError}
                    onChange={(event, newValue) => {
                      setPaymentMode(newValue);
                    }}
                  ></PSelect>
                </td>
              </tr>
              <tr>
                <td>
                  <Typography variant="body1">
                    {translate("Description")}
                  </Typography>
                </td>
                <td>
                  <PText
                    value={description}
                    error={descriptionError}
                    onChange={(e) => setDescription(e.target.value)}
                  ></PText>
                </td>
              </tr>

              {/*CODEGEN_REACT_COMPONENT ######## DO_NOT_REMOVE ###########*/}
            </tbody>
          </table>
        </Grid>
        {origin == "sale" && (
          <Grid item xs={12} sm={4}>
            <CashFlowDigitPanel onKeyPressed={onKeyPressed} />
          </Grid>
        )}
      </Grid>
    </div>
  );

  function isDataChanged() {
    if (customer || customer != "") return true;
    if (reasonCode || reasonCode != "") return true;
    if (amount || amount != "") return true;
    if (paymentMode || paymentMode != "") return true;
    if (description || description != "") return true;

    /*CODEGEN_DATA_CHANGE_DETECTION ######## DO_NOT_REMOVE ###########*/
    return false;
  }
  return (
    <div>
      {openWindow && (
        <PDialog
          content={content}
          title={windowTitle}
          maxWidth={"md"}
          fullWidth={true}
          open={openWindow}
          onCloseWindow={onCloseWindow}
          onSave={onSaveClicked}
          showPrint={true}
          onPrint={onPrintClicked}
          //onDelete={onDelete}
          mode={mode}
          isDataChanged={isDataChanged}
        ></PDialog>
      )}

      {/*confirmOpen && (
        <PConfirm
          open={confirmOpen}
          context={confirmContext}
          onButtonClicked={onYesNoClicked}
        ></PConfirm>
      )*/}
      <GenericReportViewer
        biRef={biRef}
        showMessage={props.showMessage}
        setAlert={props.setAlert}
        context={props.context}
      ></GenericReportViewer>
    </div>
  );
}
